import { createFileRoute } from '@tanstack/react-router'
import { FabricExtractorCreatePage, type FabricExtractorCreatePageProps } from '@bloo-team/product-fabric'

/** Composer shim: create an extractor from scratch (docs/extractors-requirements.md W4, guided W5). `?draft=` resumes a local authoring draft. */
function ExtractorCreateRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const { draft } = Route.useSearch()
  return <FabricExtractorCreatePage clusterId={clusterId} scopeId={scopeId} draft={draft} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/fabric/extractors_/new')({
  validateSearch: (search: Record<string, unknown>): Pick<FabricExtractorCreatePageProps, 'draft'> => ({
    draft: typeof search.draft === 'string' && /^local-[a-z0-9-]+$/.test(search.draft) ? search.draft : undefined,
  }),
  component: ExtractorCreateRoute,
})
